import { LinkRules } from '@platejs/link'
import {
  LinkElement,
  RichTextFieldLinkPlugin,
} from '@buffer-mono/popcorn/rich-text'

import { noteLinkHref } from './noteLinkHref'

export const NoteLinkPlugin = RichTextFieldLinkPlugin.configure({
  // Plate builds href through both node props and LinkElement.
  node: {
    props: ({ element }) => ({
      href:
        typeof element.url === 'string' ? noteLinkHref(element.url) : undefined,
    }),
  },
  options: {
    allowedSchemes: undefined,
    isUrl: (url) => typeof url === 'string' && noteLinkHref(url) !== undefined,
    getUrlHref: noteLinkHref,
  },
  inputRules: [
    LinkRules.autolink({ variant: 'paste' }),
    LinkRules.autolink({ variant: 'space' }),
    LinkRules.autolink({ variant: 'break' }),
  ],
}).withComponent(({ element, ...props }) => (
  <LinkElement
    {...props}
    element={{ ...element, url: noteLinkHref(element.url) ?? '' }}
  />
))
